import React, { useEffect } from "react";
import "./success.css";
import rightCheck from "../../assets/forms/Group.png";
import side_success from "../../assets/forms/side_success_img.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import FormsAside from "../../Components/FormsAside/FormsAside";
import { useTranslation } from "react-i18next";
import { notify } from "../../Components/ToastComponent";
import LibyaService, { updateSubscriptionStorage } from "./../../Utilies/Utilies/libyaService.js";

// ========== STATIC SUB CASES (for testing) – set USE_STATIC_SUB to false when using API ==========
const USE_STATIC_SUB = false;
// Change this to test each case:
// "ACTIVE_FUTURE"   → User has access (expiration in future)
// "ACTIVE_EXPIRED"  → No access, show "You do not have enough balance." when they try to play
// "CANCELLED_FUTURE"→ User has access (expiration in future)
// "CANCELLED_EXPIRED"→ No access, show "You need to reactivate your subscription." when they try to play
const STATIC_SUB_CASE = "CANCELLED_EXPIRED";
// ========== END STATIC ==========

const LIBYA_APK_URL =
  "https://mindgamers-apk-842216378405.s3.eu-central-1.amazonaws.com/GamerClub.apk";

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const hostname = window.location.hostname;
  const isLibyaApkHost =
    hostname.includes("libyad") || hostname.includes("gamerclub.ly");

  const libyaSignInFromQuery = async () => {
    let phone = searchParams.get("phone") || searchParams.get("msisdn") || "";
    if (!phone) return;

    if (!phone.startsWith("218")) {
      phone = "218" + phone;
    }
    localStorage.setItem("msisdn", phone);

    try {
      const res = await LibyaService.signInLibya(phone);
      const data = res?.data;
      if (data?.token) {
        localStorage.setItem("token", data.token);
        if (data?.user?.id) {
          localStorage.setItem("user_id", data.user.id);
        }
        localStorage.setItem(
          "userImage",
          JSON.stringify(data?.user?.avatar)
        );
      }
    } catch (e) {
      console.error("Libya signIn failed:", e);
    }
  };

  useEffect(() => {
     document.body.style.zoom = "100%";
    document.documentElement.style.zoom = "100%";
    const hostname = window.location.hostname;

    if (hostname.includes("dzo") ) {
      let phoneNumber = localStorage.getItem("phone") || "";

      if (!phoneNumber.startsWith("213")) {
        phoneNumber = "213" + phoneNumber;
      }

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "trackerEvent",
        msisdn: "+" + phoneNumber,
      });

      const trackerEvent = window.dataLayer.find(
        (item) => item.event === "trackerEvent"
      );
      console.log("Tracker Event:", trackerEvent);

      if (trackerEvent) {
        
                notify("success", t("Account Created Successfully"));
        
        setTimeout(() => {
          const toastElement = document.querySelector(".bg-success");
          if (toastElement) {
            toastElement.classList.add("subscribe-success");
            console.log("Toast element found:", toastElement);
            console.log("Current dataLayer:", window.dataLayer);
          } else {
            console.warn("Toast element not found");
          }
        }, 100);
      } else {
        console.error("Failed to add data to the data layer");
      }
    }
     if (hostname.includes("aciq") ) {
      let phoneNumber = localStorage.getItem("phone") || localStorage.getItem("msisdn") || "";

      if (!phoneNumber.startsWith("964")) {
        phoneNumber = "964" + phoneNumber;
      }

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "trackerEvent",
        msisdn: "+" + phoneNumber,
      });

      const trackerEvent = window.dataLayer.find(
        (item) => item.event === "trackerEvent"
      );
      console.log("Tracker Event:", trackerEvent);

      if (trackerEvent) {
        
                notify("success", t("Account Created Successfully"));
        
        setTimeout(() => {
          const toastElement = document.querySelector(".bg-success");
          if (toastElement) {
            toastElement.classList.add("subscribe-success");
            console.log("Toast element found:", toastElement);
            console.log("Current dataLayer:", window.dataLayer);
          } else {
            console.warn("Toast element not found");
          }
        }, 100);
      } else {
        console.error("Failed to add data to the data layer");
      }
    }
    if (hostname.includes("libyad") || hostname.includes("localhost") || hostname.includes("gamerclub.ly")) {
      (async () => {
        try {
          if (hostname.includes("libyad")) {
            await libyaSignInFromQuery();
          }
          await getSubDetails();
          const stayOnSuccessPage =
            hostname.includes("libyad") || hostname.includes("gamerclub.ly");
          if (!stayOnSuccessPage) {
            navigate("/", { replace: true });
          }
        } catch (e) {
          console.error(e);
          const stayOnSuccessPage =
            hostname.includes("libyad") || hostname.includes("gamerclub.ly");
          if (!stayOnSuccessPage) {
            navigate("/", { replace: true });
          }
        }
      })();
    }
  }, []);
  const getSubDetails = async () => {
    if (!localStorage.getItem("code") ) {
          let phoneNumber = localStorage.getItem("msisdn") || "";

    if (!phoneNumber.startsWith("218")) {
      phoneNumber = "218" + phoneNumber;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "trackerEvent",
      msisdn: "+" + phoneNumber,
    });

    const trackerEvent = window.dataLayer.find(
      (item) => item.event === "trackerEvent"
    );
    console.log("Tracker Event:", trackerEvent);

    if (trackerEvent) {
      
              notify("success", t("Account Created Successfully"));
      
      setTimeout(() => {
        const toastElement = document.querySelector(".bg-success");
        if (toastElement) {
          toastElement.classList.add("subscribe-success");
          console.log("Toast element found:", toastElement);
          console.log("Current dataLayer:", window.dataLayer);
        } else {
          console.warn("Toast element not found");
        }
      }, 100);
    } else {
      console.error("Failed to add data to the data layer");
    }
    try {
      let data;

      if (USE_STATIC_SUB) {
        // Static cases for testing – no API call
        const today = new Date();
        const futureDate = new Date(today);
        futureDate.setMonth(futureDate.getMonth() + 1);
        const pastDate = new Date(today);
        pastDate.setMonth(pastDate.getMonth() - 1);

        const staticCases = {
          ACTIVE_FUTURE: {
            status: "ACTIVE",
            expiration_date: futureDate.toISOString().split("T")[0],
            created_at: pastDate.toISOString(),
            can_cancel: true,
            has_access: true,
          },
          ACTIVE_EXPIRED: {
            status: "ACTIVE",
            expiration_date: pastDate.toISOString().split("T")[0],
            created_at: pastDate.toISOString(),
            can_cancel: false,
            has_access: false,
          },
          CANCELLED_FUTURE: {
            status: "CANCELLED",
            expiration_date: futureDate.toISOString().split("T")[0],
            created_at: pastDate.toISOString(),
            can_cancel: false,
            has_access: true,
          },
          CANCELLED_EXPIRED: {
            status: "CANCELLED",
            expiration_date: pastDate.toISOString().split("T")[0],
            created_at: pastDate.toISOString(),
            can_cancel: false,
            has_access: false,
          },
        };
        data = staticCases[STATIC_SUB_CASE] || staticCases.ACTIVE_EXPIRED;
      } else {
        const res = await LibyaService.getSubDetails();
        data = res?.data?.data;
      }

      if (data) {
        updateSubscriptionStorage(data);
      }
    } catch (e) {
      console.error(e);
    }
    }
   
  };

  return (
    <div className="signUp min-vh-100 d-flex justify-content-center align-items-center">
      <Row
        className="w-100 mx-0 d-flex justify-content-center align-items-center"
        dir={localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"}
      >
        <Col xs={12} md={7} lg={8} xl={8} className="p-0 success">
          <Row className="justify-content-center align-items-center h-100">
            <Col className="text-center" xs={12} md={8} lg={8} xl={5}>
              <h1 className="text-white">{t("Success")}!</h1>
              <p className="text-white">{t("Your Account Has Been Created")}</p>
              <div className="check">
                <img src={rightCheck} alt="check" />
              </div>
              <div className="submit-info">
                {isLibyaApkHost && (
                  <a
                    href={LIBYA_APK_URL}
                    className="btn-submit w-100 d-block text-decoration-none text-center mb-3"
                    download
                  >
                    {t("download now")}
                  </a>
                )}
                <button
                  onClick={() => navigate("/", { replace: true })}
                  className="btn-submit w-100"
                >
                  {t("Home Page")}
                </button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Success;
